import React, { useContext, useEffect} from "react";
import "./profilLogin.css"
import { AppContext } from "../../context/AppContext";
import { Link } from "react-router-dom";
const ProfilLogin = () => {

    const {firstName,imgProfil} = useContext(AppContext)

    return ( 
        <>
            <Link to={'/profilScreen'} className='iconProfil pointer' style={{backgroundSize:"cover",...(imgProfil? {backgroundImage: `url(${imgProfil})`} : {})}} >
                {imgProfil === '' && <p className="largeTitle lowOpacityHover"  >{firstName ? firstName[0].toUpperCase() : ''}</p> }
            </Link>
        </>
    )
}

export default ProfilLogin